import(/* webpackMode: "eager" */ "/vercel/path0/src/app/my_profile/page.tsx");
